module.exports = __webpack_public_path__ + "img/home_web_05.832c71d6.png";